import { connect } from 'react-redux'
import { sagaActions } from '../../../sagas'
import layoutDescriptionSelector from './layoutDescriptionSelector'
import LayoutDescription from './LayoutDescription'

export default connect(
  layoutDescriptionSelector,
  {
    requestChangeLayoutDescription: sagaActions.requestChangeLayoutDescription,
  }
)(LayoutDescription)
